// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormError_wrapper_3-7mi","icon":"FormError_icon_1qvYY","text":"FormError_text_3diba"};